
const url = new URL(window.location);

function removeWindowLocationParam(key, updateHistory) {
   if (url.searchParams.get(key)) {
      url.searchParams.delete(key);
      history.replaceState(null, '', url.toString());
   }
}

function updateWindowLocation(key, value, updateHistory) {
  if (url.searchParams.has(key)) {
    if (url.searchParams.get(key) !== value) {
      url.searchParams.delete(key);
      url.searchParams.set(key, value);
    }
  } else {
    url.searchParams.set(key, value);  
  }
  if (updateHistory === true) {
    history.replaceState(null, '', url.toString());
  }
}

var viewModel = {
  activeTab: ko.observable(),
  
  carBrand: ko.observable(),
  carBrands: ko.observableArray(),
  
  carMake: ko.observable(),
  carMakes: ko.observableArray(),

  carEngine: ko.observable(),
  carEngines: ko.observableArray(),

  carFamily: ko.observable(),
  carFamilies: ko.observableArray(),
  showCarFamilies: ko.observable(true),
    
  carPosition: ko.observable(),
  carPositions: ko.observableArray(),

  bulbPosition: ko.observable(),
  bulbPositions: ko.observableArray(),

  carOption: ko.observable(),
  carOptions: ko.observableArray(),
};

viewModel.setActiveTab = function (tab) {
  var activeBulbfinderTab = localStorage.getItem('activeBulbfinderTab');
  if (activeBulbfinderTab != tab) {
    localStorage.setItem('activeBulbfinderTab',tab);
    localStorage.setItem('carBrand',-1);
    localStorage.setItem('carMake',-1);
    localStorage.setItem('carEngine',-1);
    localStorage.setItem('carPosition',-1);
  }
  updateWindowLocation('tab', tab, true);
  viewModel.activeTab(tab);
  var scriptUrl = cars_van_db_url; // Variabila unde ai stocat URL-ul scriptului

  // Ascunde #tab-content și arată mesajul de încărcare
  if (tab === 'truck-tab') {
    scriptUrl = trucks_db_url; // Variabila unde ai stocat URL-ul scriptului
    $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca camion/tir");
    $('#CarMake option:contains("1. Alege model")').text("2. Alege model camion/tir");
  } else if (tab === 'motorcycle-tab') {
    scriptUrl = motos_db_url; // Variabila unde ai stocat URL-ul scriptului
    $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca moto");
    $('#CarMake option:contains("1. Alege model")').text("2. Alege model moto");
  } else {
    $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca auto");
    $('#CarMake option:contains("1. Alege model")').text("2. Alege model auto");
  }

  $('#tab-content').hide(); // Ascunde conținutul
  $('#loading-placeholder').show(); // Afișează mesajul "Se încarcă"

  // Încarcă scriptul JS
  loadScript(scriptUrl)
    .then(() => {
      console.log('Scriptul JS a fost încărcat cu succes.');
      $('#loading-placeholder').hide(); // Ascunde mesajul
      $('#tab-content').show(); // Afișează conținutul
      init_script();
      if (tab === 'truck-tab') {
        $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca camion / tir");
        $('#CarMake option:contains("2. Alege model")').text("2. Alege model camion / tir");
      } else if (tab === 'motorcycle-tab') {
        $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca motocicletă");
        $('#CarMake option:contains("2. Alege model")').text("2. Alege model motocicletă");
      } else {
        $('#CarBrand option:contains("1. Alege marca")').text("1. Alege marca autoturism / autoutilitară");
        $('#CarMake option:contains("2. Alege model")').text("2. Alege model auto / autoutilitară");
      }      
    })
    .catch((error) => {
      console.error('Eroare la încărcarea scriptului:', error);
      alert('Eroare la încărcarea resurselor. Vă rugăm să încercați din nou.');
    });
};

viewModel.carBrandSelect = ko.dependentObservable({
  read: viewModel.carBrand,
  write: set_carBrand,
  owner: viewModel,
});

viewModel.carMakeSelect = ko.dependentObservable({
  read: viewModel.carMake,
  write: set_carMake,
  owner: viewModel,
});

viewModel.carEngineSelect = ko.dependentObservable({
  read: viewModel.carEngine,
  write: set_carEngine,
  owner: viewModel,
});

viewModel.carPositionSelect = ko.dependentObservable({
  read: viewModel.carPosition,
  write: set_carPosition,
  owner: viewModel,
});

viewModel.bulbPositionSelect = ko.dependentObservable({
  read: viewModel.bulbPosition,
  write: set_bulbPosition,
  owner: viewModel,
});

viewModel.carFamilySelect = ko.dependentObservable({
  read: viewModel.carFamily,
  write: set_carFamily,
  owner: viewModel,
});

function get_selectedArrayIndex(array, key, selectedValue) {
  var index = -1;
  ko.utils.arrayForEach(array, function(option, i) {
      if (JSON.stringify(option[key]) === JSON.stringify(selectedValue)) {
          index = i;
      }
  });

  return index;
}

function set_carBrand(carBrand) {
  viewModel.carBrand(carBrand);
  if (carBrand !== undefined){
    viewModel.carMakes(carBrand);
    var index = get_selectedArrayIndex(viewModel.carBrands(), "m", carBrand);
    updateWindowLocation('brand_id', index, false);
    updateWindowLocation('brand_name', viewModel.carBrands()[index].n, false);
    localStorage.setItem('carBrand', index);
    localStorage.setItem('carBrandName', viewModel.carBrands()[index].n);
  } else {
    viewModel.carMakes([]);
    localStorage.setItem('carBrand', -1);
    localStorage.setItem('carBrandName', '');

    removeWindowLocationParam('brand_id');
    removeWindowLocationParam('brand_name');
  }
  if (viewModel.carMakes().length == 1) {
    set_carMake(viewModel.carMakes()[0].y);
  }
}

function set_carMake(carMake) {
  viewModel.carMake(carMake);
  if (carMake !== undefined) {
    viewModel.carEngines(carMake);
    var index = get_selectedArrayIndex(viewModel.carMakes(), "y", carMake);
    updateWindowLocation('make_id', index, false);
    updateWindowLocation('make_name', viewModel.carMakes()[index].n, false);
    localStorage.setItem('carMake', index);
    localStorage.setItem('carMakeName', viewModel.carMakes()[index].n);
  }
  else {
    viewModel.carEngines([]);
    localStorage.setItem('carMake', -1);
    localStorage.setItem('carMakeName', '');

    removeWindowLocationParam('make_id');
    removeWindowLocationParam('make_name');
  }
  if (viewModel.carEngines().length == 1) {
    set_carEngine(viewModel.carEngines()[0].c);
  }
}

function set_carEngine(carEngine) {
  viewModel.carEngine(carEngine);
  if (carEngine !== undefined) {
    viewModel.carPositions(carEngine);
    var index = get_selectedArrayIndex(viewModel.carEngines(), "c", carEngine);
    
    updateWindowLocation('engine_id', index, false);
    updateWindowLocation('engine_name', viewModel.carEngines()[index].n, true);
    localStorage.setItem('carEngine', index);
    localStorage.setItem('carEngineName', viewModel.carEngines()[index].n);
  }
  else {
    viewModel.carPositions([]);
    localStorage.setItem('carEngine', -1);
    localStorage.setItem('carEngineName', '');
    
    removeWindowLocationParam('engine_id');
    removeWindowLocationParam('engine_name');
  }

  if (viewModel.carPositions().length == 1) {
    set_carPosition(viewModel.carPositions()[0].s);
  }
}

function set_carPosition(carPosition) {
  viewModel.carPosition(carPosition);
  if (carPosition !== undefined) {
    viewModel.bulbPositions(carPosition);
    var index = get_selectedArrayIndex(viewModel.carPositions(), "s", carPosition);
    
    updateWindowLocation('position_id', index, true);
    localStorage.setItem('carPosition', index);
  } else {
    viewModel.bulbPositions([]);
    localStorage.setItem('carPosition', -1);
    
    removeWindowLocationParam('position_id');
  }
  if (viewModel.bulbPositions().length == 1) {
    set_bulbPosition(viewModel.bulbPositions()[0].f);
  }
}

function set_bulbPosition(bulbPosition) {
  viewModel.bulbPosition(bulbPosition);
  if (bulbPosition !== undefined) {
    viewModel.carFamilies(bulbPosition);
    var index = get_selectedArrayIndex(viewModel.bulbPositions(), "f", bulbPosition);
    
    updateWindowLocation('bulbposition_id', index, true);
    localStorage.setItem('bulbPosition', index);
  } else { 
    viewModel.carFamilies([]);
    localStorage.setItem('bulbPosition', -1);
    
    removeWindowLocationParam('bulbposition_id');
  }
  
  if (viewModel.carFamilies().length == 1) {
    set_carFamily(viewModel.carFamilies()[0].b);
    viewModel.showCarFamilies(false);
  } else {
    viewModel.showCarFamilies(true);    
  }
}

function set_carFamily(carFamily) {
  viewModel.carFamily(carFamily);
  if (carFamily !== undefined) {
    viewModel.carOptions(carFamily);
    var index = get_selectedArrayIndex(viewModel.carFamilies(), "b", carFamily);
    
    updateWindowLocation('carfamily_id', index, true);
    localStorage.setItem('carFamily', index);
  } else {
    viewModel.carOptions([]);
    localStorage.setItem('carFamily', -1);
    
    removeWindowLocationParam('carfamily_id');
  }
}

viewModel.result = ko.computed(function () {
  var result = "";
  $.each(viewModel.carOptions(), function (i, index) {
    var bulb_code = bulbs_db[index].toUpperCase();
    if (site_products[bulb_code] === undefined) return;
    $.each(site_products[bulb_code], function (i, product) {
      if (display_desktop_grid)
        result += '<div class="bulbFinder-productCard grid__item">';
      else
        result += '<div class="bulbFinder-productCard">';
        
      result += ' <span class="h4">';
      result += '  <a href="/products/' + product.handle + url.search +'" class="full-unstyled-link bulb-finder-product">' + product.title + '</a>';
      result += ' </span>';
      result += ' <div class="image center">';
      result += '  <a href="/products/' + product.handle + url.search + '" class="bulb-finder-product"><img src="' + product.featured_image + '"></a>';
      result += ' </div>';


      // Verificam daca produsul este la reducere
      let isOnSale = product.compare_at_price && product.compare_at_price > product.price;
      let comparePriceFormatted = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) + ' lei' : null;
      let priceFormatted = (product.price / 100).toFixed(2) + ' lei';
  
      // Cream containerul de pret
      result += '  <div class="price center ' + (isOnSale ? 'price--on-sale' : '') + '">';
      result += '    <div class="price__container">';
  
      if (isOnSale) {
          // Pret obisnuit (taiat)
          result += '      <div class="price__sale">';
          result += '        <span class="visually-hidden visually-hidden--inline">Pret obisnuit</span>';
          result += '        <span><s class="price-item price-item--regular">' + comparePriceFormatted + '</s></span>';
  
          // Pret redus
          result += '        <span class="visually-hidden visually-hidden--inline">Pret redus</span>';
          result += '        <span class="price-item price-item--sale price-item--last">' + priceFormatted + '</span>';
          result += '      </div>';
      } else {
          // Daca nu e la reducere, afisam doar pretul normal
          result += '      <div class="price__regular">';
          result += '        <span class="price-item price-item--regular">' + priceFormatted + '</span>';
          result += '      </div>';
      }
  
      // Adaugam unit-price, daca este cazul (pentru produse cu pret per unitate)
      result += '      <small class="unit-price caption hidden">';
      result += '        <span class="visually-hidden">Pret unitar</span>';
      result += '        <span class="price-item price-item--last">';
      result += '          <span></span>';
      result += '          <span aria-hidden="true">/</span>';
      result += '          <span class="visually-hidden">&nbsp;pe&nbsp;</span>';
      result += '          <span></span>';
      result += '        </span>';
      result += '      </small>';
  
      result += '    </div>'; // Inchidem `price__container`
      result += '  </div>'; // Inchidem `price`
      
      result += ' <div class="linkto">';
      result += '  <a href="/products/' + product.handle + '" class="button bulb-finder-product">Vezi produsul</a>';
      result += ' </div>';
      result += '</div>';
    });
  });

  return result;
});

$(function () {
  ko.applyBindings(viewModel);
  var activeBulbfinderTab = localStorage.getItem('activeBulbfinderTab');

  if (url.searchParams.has('tab')) {
    var tab = url.searchParams.get('tab');
    if (tab)
      activeBulbfinderTab = tab;
  }
  
  if (activeBulbfinderTab) {
    viewModel.setActiveTab(activeBulbfinderTab); // Default tab
  } else {
    viewModel.setActiveTab('car-van-tab'); // Default tab
  }
});

function init_script() {
  var allowed_tags = all_tags.filter(function (tag) {
    return !["LED","LED-MOTO","LED-TRUCK"].includes(tag.toUpperCase());
  });
  viewModel.carBrands(filter_database(database, bulbs_db, allowed_tags));

  //load cache
  var carBrand = localStorage.getItem('carBrand');
  if (url.searchParams.has('brand_id')) {
    var id = parseInt(url.searchParams.get('brand_id'));
    if (!isNaN(id) && id >= 0 && id < viewModel.carBrands().length)
      carBrand = id;
  }
  
  if (carBrand >= 0 && viewModel.carBrands()[carBrand] !== undefined) {
    set_carBrand(viewModel.carBrands()[carBrand].m);
    var carMake = localStorage.getItem('carMake');
    
    if (url.searchParams.has('make_id')) {
      var id = parseInt(url.searchParams.get('make_id'));
      if (!isNaN(id) && id >= 0 && id < viewModel.carMakes().length)
        carMake = id;
    }
    
    if (carMake >= 0 && viewModel.carMakes()[carMake] !== undefined) {
      set_carMake(viewModel.carMakes()[carMake].y);
      var carEngine = localStorage.getItem('carEngine');
    
      if (url.searchParams.has('engine_id')) {
        var id = parseInt(url.searchParams.get('engine_id'));
        if (!isNaN(id) && id >= 0 && id < viewModel.carEngines().length)
          carEngine = id;
      }
      
      if (carEngine >= 0 && viewModel.carEngines()[carEngine] !== undefined) {
        set_carEngine(viewModel.carEngines()[carEngine].c);
        var carPosition = localStorage.getItem('carPosition');
    
        if (url.searchParams.has('position_id')) {
          var id = parseInt(url.searchParams.get('position_id'));
          if (!isNaN(id) && id >= 0 && id < viewModel.carPositions().length)
            carPosition = id;
        }
        
        if (carPosition >= 0 && viewModel.carPositions()[carPosition] !== undefined) {
          set_carPosition(viewModel.carPositions()[carPosition].s);
          var bulbPosition = localStorage.getItem('bulbPosition');
      
          if (url.searchParams.has('bulbposition_id')) {
            var id = parseInt(url.searchParams.get('bulbposition_id'));
            if (!isNaN(id) && id >= 0 && id < viewModel.bulbPositions().length)
              bulbPosition = id;
          }
          
          if (bulbPosition >= 0 && viewModel.bulbPositions()[bulbPosition] !== undefined) {
            set_bulbPosition(viewModel.bulbPositions()[bulbPosition].f);
            var carFamily = localStorage.getItem('carFamily');
        
            if (url.searchParams.has('carfamily_id')) {
              var id = parseInt(url.searchParams.get('carfamily_id'));
              if (!isNaN(id) && id >= 0 && id < viewModel.carFamilies().length)
                carFamily = id;
            }
            if (carFamily >= 0 && viewModel.carFamilies()[carFamily] !== undefined) {
              set_carFamily(viewModel.carFamilies()[carFamily].b);
            }
          }
        }
      }      
    }    
  }  
}

function filter_database(database, bulbs_db, allowed_tags) {
  simplified_results = [];
  $.each(database, function (i, data) {
    var brand = {
      n: data.n,
      m: [],
    };
    $.each(data.m, function (i, data) {
      var make = {
        n: data.n,
        y: [],
      };
      
      $.each(data.y, function (i, data) {
        var year = {
          n: data.n,
          c: [],
        };

        $.each(data.c, function (i, data) {
          var category = {
            n: data.n,
            s: [],
          };

          $.each(data.s, function (i, data) {
            var subCategory = {
              n: data.n,
              f: [],
            };

            $.each(data.f, function (i, data) {
              var family_name = data.n;
              if (family_name === 'Other') family_name = 'Standard';
              var family = {
                n: family_name,
                b: [],
              };

              $.each(data.b, function (i, data) {
                var bulb = data;

                if (bulbs_db[bulb] === undefined) return;
                if (!allowed_tags.includes(bulbs_db[bulb].toUpperCase()))
                  return;

                family.b.push(bulb);
              });

              if (!family.b.length) return;

              subCategory.f.push(family);
            });

            if (!subCategory.f.length) return;

            category.s.push(subCategory);
          });

          if (!category.s.length) return;

          year.c.push(category);
        });

        if (!year.c.length) return;

        make.y.push(year);
      });

      if (!make.y.length) return;

      brand.m.push(make);
    });

    if (!brand.m.length) return;

    simplified_results.push(brand);
  });

  return simplified_results;
}

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}